import React from 'react';

export enum ModalType {
  Update = '서비스 점검 안내',
  Emergency = '서비스 긴급 점검 안내',
  Preview = '서비스 업데이트 예정 안내'
}

const getContents = (matches: boolean): Record<string, JSX.Element> => ({
  [ModalType.Emergency]: (
    <>
      서비스 접속지연 및 장애 현상이 발견되어 긴급 서버 대응 중이나
      {!matches && <br />}
      &nbsp;<b>서비스 이용이 불안정할 수 있습니다.</b>
      <br />
      이용에 불편을 드려 죄송하며, 신속하게 정상 서비스가 제공될 수 있도록
      최선을 다해 노력하겠습니다. 서비스 이용 중 불편하신 점 및 장애 사항은
      &nbsp;<b>우측하단 채널톡으로 문의</b>주시면 빠른 조치토록 하겠습니다.
    </>
  ),
  [ModalType.Update]: (
    <>
      서비스를 이용해 주시는 고객님께 감사드립니다.
      {!matches && <br />}
      서비스 업데이트 시간 동안 사용이 일시 중단될 예정이오니 이용에 참고
      부탁드립니다.
      {!matches && <br />}더 나은 서비스를 제공하기 위한 과정임을 너그럽게 양해
      부탁드립니다.
    </>
  ),
  [ModalType.Preview]: (
    <>
      서비스를 이용해 주시는 고객님께 감사드립니다. {!matches && <br />}
      서비스 점검 시간 동안 사용이 일시 중단될 예정이오니
      {!matches && <br />} 이용에 참고 부탁드립니다. 더 나은 서비스를 제공하기
      {!matches && <br />}
      위한 과정임을 너그럽게 양해 부탁드립니다.
    </>
  )
});

export default getContents;
